import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { MaterialFactor, MaterialFactorUpdateDto } from 'models/mooring/MaterialFactor';
import { AuthHttpClient } from './auth-http-client';
import { BaseApiService } from './base-api-service';

@autoinject
export class MaterialFactorService extends BaseApiService<MaterialFactor> {
  constructor(
    private client: NetlogHttpClient,
    protected httpClient: AuthHttpClient
  ) {
    super(httpClient, MaterialFactor);
  }

  public async list() {
    return await this.client.get<MaterialFactor[]>({
      url: `api/mooring-material-factor/list`,
      model: MaterialFactor,
    });
  }

  public async updateAndCreate(id: number, data: MaterialFactorUpdateDto) {
    await this.client.patch({
      url: `api/mooring-material-factor/updateAndCreate/${id}`,
      data: data,
    });
  }

  public async getActiveMaterialFactors() {
    return await this.client.get<MaterialFactor>({
      url: `api/mooring-material-factor/active`,
      model: MaterialFactor,
    });
  }
}
